import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse  } from '@angular/common/http';
import { Observable } from 'rxjs';

import * as theGlobals from '../shared/globals';

import { IUser } from '../shared/classes/user';
import { IFact } from '../shared/classes/fact';
import { INotice } from '../shared/classes/notice';
// import { not } from '@angular/compiler/src/output/output_ast';

@Injectable()
export class SystemService {

        private myUrl = theGlobals.setEnv().funcUrl;

    constructor(private http: HttpClient) {

     }

    validateUser(userEmail: string): Observable<any>
    {
      const xUrl = this.myUrl + '/user/validate';
      return this.http.post(xUrl, userEmail);
    }
    getDisclaimer(): Observable<any>
    {
      const xUrl = this.myUrl + '/user/warning/0';
      return this.http.get<any>(xUrl);

    }
    confirmDisclaimer(userEmail: string): Observable<any>
    {
      const xUrl = this.myUrl + '/user/confirm';
      return this.http.post(xUrl, userEmail);
    }
    // get list of AppealsUsers with an assessor-related role/type
    getAppraiserUserList(): Observable<IUser[]> {
      const xUrl = this.myUrl + '/user/appraisers';
      return this.http.get<IUser[]>(xUrl);
    }
    getUserList(): Observable<IUser[]> {
        const xUrl = this.myUrl + '/user';
        return this.http.get<IUser[]>(xUrl);
    }
    saveUser(user: IUser): Observable<any> {
        const xUrl = this.myUrl + '/user';
        // alert('userId: '+user.id)
        if (user.id === 0) {
            return this.http.post(xUrl, user);
        } else {
            return this.http.put(xUrl + '/' + user.id, user);
        }
    }

    deleteUser(user: IUser): Observable<any> {
        const xUrl = this.myUrl + '/user';
        return this.http.delete(xUrl + '/' + user.id);
    }

    getFactList(): Observable<IFact[]>{
        const xUrl = this.myUrl + '/facts';
        return this.http.get<IFact[]>(xUrl);

    }

    saveFact(fact: IFact): Observable<any> {
        const xUrl = this.myUrl + '/facts';
        if (fact.id === 0) {
            return this.http.post(xUrl, fact);
        } else {
            return this.http.put(xUrl + '/' + fact.id, fact);
        }
    }

    deleteFact(fact: IFact): Observable<any> {
        const xUrl = this.myUrl + '/facts/' + fact.id;
        return this.http.delete(xUrl);
    }

    getNoticeList(): Observable<INotice[]>{
        const xUrl = this.myUrl + '/noticetext';
        return this.http.get<INotice[]>(xUrl);

    }

    saveNotice(notice: INotice): Observable<any> {
        const xUrl = this.myUrl + '/noticetext';
        if (notice.id === 0) {
            return this.http.post(xUrl, notice);
        } else {
            return this.http.put(xUrl + '/' + notice.id, notice);
        }
    }

    deleteNotice(notice: INotice): Observable<any> {
        const xUrl = this.myUrl + '/noticetext/' + notice.id;
        return this.http.delete(xUrl);
    }

    getUser(userid: number): Observable<any> {
        const xUrl = this.myUrl + '/user/' + userid;
        return this.http.get<any>(xUrl);
    }

    // get Agenda Categories order list/dictionary
    getAgendaCategories(): Observable<any>
    {
      const xUrl = this.myUrl + '/dict/agendaorder';
      return this.http.get<any>(xUrl);
    }

    // update Agenda Categories order list/dictionary
    saveAgendaCategOrder(categList: any[]): Observable<any>
    {
      const xUrl = this.myUrl + '/dict/agendareorder';
      return this.http.post(xUrl, categList);
    }

    getAuditTrail(): Observable<any>
    {
      const xUrl = this.myUrl + '/system/audit';
      return this.http.get<any>(xUrl);

    }
    private handleError(err: HttpErrorResponse) {
        // in a real world app, we may send the error to some remote logging infrastructure
        // instead of just logging it to the console
        let errorMessage = '';
        const status = err.status;
        if (err.error instanceof Error) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
        }
        console.error(errorMessage);
        return Observable.throw(status);
    }
}
